import React, { useState } from "react";
import hicon from "../../images/icon/ser-01.svg";
import { Fade } from "react-awesome-reveal";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";

const DataCenterFaqSection = (props) => {
  const [open, setOpen] = useState("1");
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <section className="faq pb-140 mt-5">
      <div className="container">
        <div className="sec-title--two text-center mb-60">
          <Fade
            direction="down"
            triggerOnce={"false"}
            duration={1000}
            delay={9}
          >
            <div>
              <div
                className="sub-title wow fadeInDown"
                data-wow-duration="600ms"
              >
                <img src={hicon} alt="" />
                Dúvidas Frequentes
              </div>
            </div>
          </Fade>
          <Fade direction="up" triggerOnce={"false"} duration={1200} delay={9}>
            <div>
              <h2
                className="title wow fadeInDown"
                data-wow-delay="150ms"
                data-wow-duration="600ms"
              >
                Tire todas suas dúvidas sobre Cloud VPS
              </h2>
            </div>
          </Fade>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div
              className="xb-faq wow fadeInUp"
              data-wow-delay="200ms"
              data-wow-duration="600ms"
            >
              <Accordion
                open={open}
                toggle={toggle}
                className="accordion_box clearfix list-unstyled"
              >
                <AccordionItem className="block">
                  <AccordionHeader targetId="1" className="acc-btn">
                    <span className="number me-3">01</span>O que é um Cloud VPS
                    e como funciona?
                    <span className="arrow"></span>
                  </AccordionHeader>
                  <AccordionBody accordionId="1" className="acc_body">
                    <div className="content">
                      <p>
                        Um Cloud VPS (Virtual Private Server) é um servidor
                        virtual privado hospedado na nuvem com recursos
                        dedicados garantidos. Combina a flexibilidade da nuvem
                        com a performance de um servidor dedicado:
                      </p>
                      <ul
                        className="list-unstyled"
                        style={{ marginTop: "15px" }}
                      >
                        <li>✓ vCPU e RAM dedicados exclusivamente para você</li>
                        <li>✓ Armazenamento SSD NVMe de alta performance</li>
                        <li>✓ IP dedicado incluso, sem NAT ou restrições</li>
                        <li>✓ Autonomia completa para gerenciar tudo</li>
                        <li>✓ Infraestrutura nacional de baixa latência</li>
                      </ul>
                      <p style={{ marginTop: "15px" }}>
                        Ideal para desenvolvedores, agências, integradores e
                        projetos que exigem liberdade técnica com custo
                        otimizado.
                      </p>
                    </div>
                  </AccordionBody>
                </AccordionItem>

                <AccordionItem className="block">
                  <AccordionHeader targetId="2" className="acc-btn">
                    <span className="number me-3">02</span>Quanto tempo leva
                    para ativar meu Cloud VPS?
                    <span className="arrow"></span>
                  </AccordionHeader>
                  <AccordionBody accordionId="2" className="acc_body">
                    <div className="content">
                      <p>
                        <strong>
                          Seu Cloud VPS fica pronto em poucos minutos!
                        </strong>{" "}
                        Nossa infraestrutura automatizada permite
                        provisionamento instantâneo:
                      </p>
                      <ul
                        className="list-unstyled"
                        style={{ marginTop: "15px" }}
                      >
                        <li>✓ Deploy automatizado em até 5 minutos</li>
                        <li>✓ Sistema operacional pré-configurado</li>
                        <li>✓ Painel de controle imediatamente disponível</li>
                        <li>✓ Acesso SSH/RDP liberado automaticamente</li>
                        <li>✓ Monitoramento ativo desde o primeiro minuto</li>
                      </ul>
                      <p style={{ marginTop: "15px" }}>
                        Para migrações de dados de outros provedores, oferecemos
                        suporte gratuito e assistido.
                      </p>
                    </div>
                  </AccordionBody>
                </AccordionItem>

                <AccordionItem className="block">
                  <AccordionHeader targetId="3" className="acc-btn">
                    <span className="number me-3">03</span>Que tipo de suporte
                    técnico está incluído?
                    <span className="arrow"></span>
                  </AccordionHeader>
                  <AccordionBody accordionId="3" className="acc_body">
                    <div className="content">
                      <p>
                        Oferecemos suporte técnico especializado 24/7/365 com
                        diferentes níveis:
                      </p>
                      <ul
                        className="list-unstyled"
                        style={{ marginTop: "15px" }}
                      >
                        <li>
                          ✓ <strong>Suporte Básico:</strong> Chat, ticket e
                          telefone 24/7
                        </li>
                        <li>
                          ✓ <strong>Suporte Prioritário:</strong> SLA de 30
                          minutos para resposta
                        </li>
                        <li>
                          ✓ <strong>Suporte Dedicado:</strong> Técnico exclusivo
                          para sua conta
                        </li>
                        <li>✓ Monitoramento proativo da infraestrutura</li>
                        <li>✓ Consultoria para otimização de recursos</li>
                        <li>✓ Suporte para migração e configuração inicial</li>
                      </ul>
                      <p style={{ marginTop: "15px" }}>
                        Nossa equipe é formada por especialistas certificados em
                        infraestrutura cloud, Microsoft e Linux.
                      </p>
                    </div>
                  </AccordionBody>
                </AccordionItem>

                <AccordionItem className="block">
                  <AccordionHeader targetId="4" className="acc-btn">
                    <span className="number me-3">04</span>Posso escalar
                    recursos conforme necessário?
                    <span className="arrow"></span>
                  </AccordionHeader>
                  <AccordionBody accordionId="4" className="acc_body">
                    <div className="content">
                      <p>
                        <strong>
                          Sim! A escalabilidade é uma das principais vantagens:
                        </strong>
                      </p>
                      <ul
                        className="list-unstyled"
                        style={{ marginTop: "15px" }}
                      >
                        <li>
                          ✓ <strong>Vertical:</strong> Aumente CPU, RAM e
                          storage instantaneamente
                        </li>
                        <li>
                          ✓ <strong>Horizontal:</strong> Adicione novos
                          servidores em minutos
                        </li>
                        <li>
                          ✓ <strong>Auto-scaling:</strong> Recursos ajustados
                          automaticamente por demanda
                        </li>
                        <li>
                          ✓ <strong>Pay-as-you-grow:</strong> Pague apenas pelo
                          que usar
                        </li>
                        <li>
                          ✓ <strong>Sem downtime:</strong> Escalação sem
                          interrupção dos serviços
                        </li>
                      </ul>
                      <p style={{ marginTop: "15px" }}>
                        Através do portal, você pode monitorar uso em tempo real
                        e ajustar recursos com poucos cliques.
                      </p>
                    </div>
                  </AccordionBody>
                </AccordionItem>

                <AccordionItem className="block">
                  <AccordionHeader targetId="5" className="acc-btn">
                    <span className="number me-3">05</span>Qual é o SLA de
                    disponibilidade garantido?
                    <span className="arrow"></span>
                  </AccordionHeader>
                  <AccordionBody accordionId="5" className="acc_body">
                    <div className="content">
                      <p>
                        Oferecemos <strong>SLA de 99.9% de uptime</strong> com
                        as seguintes garantias:
                      </p>
                      <ul
                        className="list-unstyled"
                        style={{ marginTop: "15px" }}
                      >
                        <li>✓ Infraestrutura redundante em todos os níveis</li>
                        <li>✓ Monitoramento 24/7 com alertas automáticos</li>
                        <li>✓ Geradores e UPS para energia ininterrupta</li>
                        <li>
                          ✓ Múltiplos links de internet com failover automático
                        </li>
                        <li>
                          ✓ Créditos de compensação em caso de não cumprimento
                        </li>
                      </ul>
                      <p style={{ marginTop: "15px" }}>
                        Nossos datacenters possuem certificação Tier III e
                        seguem os mais altos padrões de disponibilidade.
                      </p>
                    </div>
                  </AccordionBody>
                </AccordionItem>

                <AccordionItem className="block">
                  <AccordionHeader targetId="6" className="acc-btn">
                    <span className="number me-3">06</span>Como é a segurança do
                    datacenter?
                    <span className="arrow"></span>
                  </AccordionHeader>
                  <AccordionBody accordionId="6" className="acc_body">
                    <div className="content">
                      <p>
                        Nosso datacenter implementa múltiplas camadas de
                        proteção:
                      </p>
                      <ul
                        className="list-unstyled"
                        style={{ marginTop: "15px" }}
                      >
                        <li>
                          ✓ <strong>Tier III:</strong> Certificação Tier III com
                          99.982% de disponibilidade
                        </li>
                        <li>
                          ✓ <strong>Segurança Física:</strong> Controle de
                          acesso biométrico 24/7
                        </li>
                        <li>
                          ✓ <strong>Energia Redundante:</strong> Múltiplos
                          geradores e sistemas UPS
                        </li>
                        <li>
                          ✓ <strong>Rede Redundante:</strong> Múltiplos links
                          com failover automático
                        </li>
                        <li>
                          ✓ <strong>Monitoramento:</strong> NOC 24/7 com alertas
                          proativos
                        </li>
                        <li>
                          ✓ <strong>Compliance:</strong> LGPD, ISO 27001, SOC 2
                        </li>
                      </ul>
                      <p style={{ marginTop: "15px" }}>
                        A segurança da VM é de sua responsabilidade - você tem
                        autonomia completa para configurar firewalls e políticas
                        de acesso.
                      </p>
                    </div>
                  </AccordionBody>
                </AccordionItem>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DataCenterFaqSection;
